import {
  IoPlayOutline,
  IoMailOutline,
  IoSyncOutline,
  IoEllipsisHorizontalOutline,
  IoTrashOutline,
} from "react-icons/io5";
import { useState } from "react";
import {
  postInvoiceAsync,
  sendInvoiceAsync,
  voidInvoiceAsync,
} from "../../../../services/invoiceService";
import TextboxSearch from "../../../../components/common/TextboxSearch";
import InvoicesTable from "./components/InvoicesTable";
import Modal from "../../../../components/common/Modal";
import Loader from "../../../../components/common/Loader";
import InvoiceConfirmation from "./components/InvoiceConfirmation";
import Toaster from "./../../../../components/common/Toaster";
import Dropdown from "./../../../../components/common/Dropdown";

const Invoices = ({ id }) => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "invoice_number", order: "asc" },
  });

  const actions = (data) => {
    const post_invoice_disabled = data.is_paid ? true : false;
    const email_invoice_disabled = !data.is_posted_value ? true : false;
    const void_disabled = data.is_posted_value ? true : false;

    return [
      [
        {
          name: "Post Invoice",
          icon: <IoPlayOutline className="mr-3 text-green-500" />,
          action: () => handlePostInvoice(data.id),
          is_disabled: post_invoice_disabled,
        },
        {
          name: "Send Invoice via Email",
          icon: <IoMailOutline className="mr-3 text-blue-500" />,
          action: () => handleSendInvoice(data.id),
          is_disabled: email_invoice_disabled,
        },
        {
          name: "Void Invoice",
          icon: <IoTrashOutline className="mr-3 text-red-500" />,
          action: () => handleVoidInvoice(data.id),
          is_disabled: void_disabled,
        },
      ],
    ];
  };

  const columns = [
    { path: "invoice_number", label: "Invoice No." },
    { path: "amount", label: "Amount" },
    { path: "period_start", label: "Period Start" },
    { path: "period_end", label: "Period End" },
    { path: "is_posted", label: "Posted" },
    { path: "created_on", label: "Sent On" },
    {
      key: "actions",
      content: (invoice) => {
        return (
          <Dropdown
            items={actions(invoice)}
            icon={<IoEllipsisHorizontalOutline />}
          />
        );
      },
    },
  ];

  const handleOptionsChange = (options) => setTableOptions(options);

  const handleSearch = (query) => {
    const options = { ...tableOptions };

    if (options.search_query !== query) {
      options.search_query = query;
      options.current_page = 1;
      handleOptionsChange(options);
    }
  };

  const handlePostInvoice = async (id) => {
    try {
      setIsLoading(true);
      await postInvoiceAsync(id);
      Toaster.Success("Invoice Posted Successfully");
      handleSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleVoidInvoice = async (id) => {
    try {
      setIsLoading(true);
      await voidInvoiceAsync(id);
      Toaster.Success("Invoice Voided Successfully");
      handleSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendInvoice = async (id) => {
    try {
      setIsLoading(true);
      await sendInvoiceAsync(id);
      Toaster.Success("Invoice Sent Successfully");
      handleSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccess = () => {
    const options = { ...tableOptions };
    setTableOptions(options);
    setShowModal(false);
  };

  return (
    <div className="card p-8">
      {isLoading && <Loader />}
      <div className="block sm:flex justify-between items-center">
        <div>
          <p className="text-gray-400 text-sm">Account Invoices</p>
          <span className="text-gray-400 text-xs">
            List of Account Invoices
          </span>
        </div>
        <div className="mt-5 sm:mt-0">
          <button
            className="button button-primary"
            onClick={() => setShowModal(true)}
          >
            <IoSyncOutline className="mr-2" />
            Generate Invoices
          </button>
        </div>
      </div>
      <div className="block sm:justify-between items-center mt-8">
        <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
      </div>
      <div className="mt-8">
        <InvoicesTable
          id={id}
          columns={columns}
          tableOptions={tableOptions}
          onChange={handleOptionsChange}
        />
      </div>
      <Modal
        isOpen={showModal}
        isLoading={isLoading}
        onClose={() => setShowModal(false)}
      >
        <InvoiceConfirmation
          id={id}
          setLoading={setIsLoading}
          onClose={() => setShowModal(false)}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default Invoices;
